import { HttpRequest } from '@angular/common/http';

export function isApiRequest(req: HttpRequest<any>) {
  return req.url.indexOf('/api/') > -1;
}

/**
 * Endpoints that establish or recover a session and therefore run without one. They must never
 * carry a bearer token, and - the reason this exists - must never trigger the access-token refresh
 * flow: a stale expired token in localStorage would otherwise send the login request itself into
 * a refresh, and a failed refresh wipes storage and reloads the page, destroying the in-flight
 * login. That was the "first login attempt always fails" bug.
 *
 * refresh-token is deliberately absent: it still receives the (expired) header today, and the
 * interceptor already guards against it recursing into itself.
 */
const PRE_AUTH_ENDPOINTS = [
  '/api/account/login',
  '/api/account/register',
  '/api/account/verify',
  '/api/account/forgot-password',
  '/api/account/reset-password',
  '/api/account/magic-link',
  '/api/account/magic-link-confirm',
  '/api/account/google-login-url',
  '/api/account/google-login-callback',
];

export function isPreAuthRequest(req: HttpRequest<any>) {
  return PRE_AUTH_ENDPOINTS.some((endpoint) => req.url.indexOf(endpoint) > -1);
}
